import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F0F1F2",
      "fill-rule": "evenodd",
      d: "M16 29.335c-7.364 0-13.334-5.97-13.334-13.334S8.636 2.668 15.999 2.668s13.334 5.97 13.334 13.333-5.97 13.334-13.334 13.334",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#7D818A",
      d: "m12.229 10.344 3.77 3.772 3.77-3.772 1.888 1.886-3.773 3.771 3.773 3.77-1.887 1.887L16 17.886l-3.771 3.772-1.887-1.886 3.772-3.77-3.772-3.772z"
    }, null, -1)
  ]))]))
}
export default { render: render }